import { api } from '../../api/config';

import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
import Loader from '../../components/general/loader/Loader';
import Row from '../../components/builder/Row';

export default function Preview() {

    const { id } = useParams();
    const [content, setContent] = useState([]);
    const [loading, setLoading] = useState(true);
    function decodeHtmlEntities(str) {
        var doc = new DOMParser().parseFromString(str, 'text/html');
        return doc.documentElement.textContent;
    }
    const handlePreview = () => {
        setLoading(true);
        api.post('/page/getPreview', { id: id })
        .then(res => {
            if (res.data.success) { 
                const decodedData = decodeHtmlEntities(res?.data?.content);
                const jsonData = JSON.parse(decodedData);
                setContent(jsonData); 
            }
        })
        .finally(() => { setLoading(false); })
    }

    useEffect(() => {
        handlePreview();
        //eslint-disable-next-line
    }, [id]);

    return (
        !loading ?
        content.map((row) => ( <Row key={row.id} row={row} /> ))
        :
        <Loader />
    )
}